//src/components/forGeneralPractitionersSolutionsData.js
import NewPatients from '../assets/attract_more_patient.jpg';
import PatientConnectivity from '../assets/Enhance_your_patient_experience.jpg';
import MaintainPatientCare from '../assets/Deliver_better_care.jpg';
import PaymentsWithEase from '../assets/get_paid_faster.jpg';
import ExploreData from '../assets/get_deeper_insights.jpg';
import GeneralImplementation from '../assets/automate_your_practice.jpg';

const forGeneralPractitionersSolutionsData = [
    {
        id: 1,
        title: "Reach new patients",
        text: "In a landscape where 69% of patients have visited a doctor in the past 12 months, it's crucial for your Consultant Physicians  practice to stand out. Doclivo simplifies the process, ensuring patients can easily find your family practitioners through search engine optimization and targeted digital marketing. Create a positive first impression with automated reputation management and polished online profiles, allowing patients to seamlessly connect with your practice.",
        image: NewPatients,
        buttonLabel: "Learn more",
    },
    {
        id: 2,
        title: "Enhance Patient Connectivity",
        text: "Quality care is essential for primary care practices. With nearly 80% of patients willing to switch doctors for greater convenience, Doclivo simplifies the process. It ensures easy appointment booking, prompt responses to inquiries, seamless access to records, and straightforward billing. Back-end automation translates to front-end convenience without requiring additional effort from you.",
        image: PatientConnectivity,
        buttonLabel: "Learn more",
    },
    {
        id: 3,
        title: "Maintain Focus on Patient Care",       
        text: "Minimize tool management time. Our certified, cloud-based EHR seamlessly integrates provider scheduling, clinical notes, flowsheets, eRx, eLabs, telehealth, and more—all in one place. Leverage our mobile app to securely provide on-the-go care to your families.",
        image: MaintainPatientCare,
        buttonLabel: "Learn more",
    },
    {
        id: 4,
        title: "Streamline Your Payments with Ease",
        text: "Eliminate frustration from medical billing and payments. Doclivo's billing and payments solutions make it easy for patients to understand and settle bills. Intuitively manage your independent family practice, save time with automation, and enhance your revenue cycle.",
        image: PaymentsWithEase,
        buttonLabel: "Learn more",
    },
    {
        id: 5,
        title: "Explore Your Data in Depth",
        text: "Consultant Physicians  providers enhance care delivery with clear data insights. Doclivo provides instant access to analytics covering every aspect of your practice, from growth to revenue. Ensure security with HIPAA-compliant cloud storage and customize your data exploration with APIs that seamlessly integrate with third-party applications.",
        image: ExploreData,
        buttonLabel: "Learn more",
    },
    {
        id: 6,
        title: "Effortless Implementation",
        text: "Switch seamlessly without disrupting your practice. Doclivo ensures an easy start with no requirement for IT expertise or complex processes. Our onboarding, training, and continuous support will guide you every step of the way, ensuring your Consultant Physicians  practice continues without missing a beat.",
        image: GeneralImplementation,
        buttonLabel: "Learn more",
    },
    
   
    // Add more items as needed

];

export default forGeneralPractitionersSolutionsData;
